import styled from "styled-components";

export const DragAndDropUploadStyles = styled.div`
  .dragAndDropContainer {
    height: 124px;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px dashed ${({ theme }) => theme.colors.accent[300]};
    border-radius: ${({ theme }) => theme.radius[4]};
    outline: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .text {
      color: ${({ theme }) => theme.colors.semantic.text.placeholder};
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.body.b1.weight};
      font-size: ${({ theme }) => theme.typography.body.b1.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    }

    .browseButton {
      position: absolute;
      bottom: ${({ theme }) => theme.spacing[12]};
      right: ${({ theme }) => theme.spacing[12]};
      background: ${({ theme }) => theme.colors.semantic.container.white};
      border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
      border-radius: ${({ theme }) => theme.radius[8]};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};
    }
  }

  .imagesContainer {
    display: flex;
    flex-wrap: wrap;
    margin-top: ${({ theme }) => theme.spacing[12]};

    .imageCard {
      width: 220px;
      height: 136px;
      overflow: hidden;
      position: relative;
      background: ${({ theme }) => theme.colors.primary[400]};
      margin: 0 ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[8]} 0;

      .prioIcon {
        position: absolute;
        top: ${({ theme }) => theme.spacing[8]};
        left: ${({ theme }) => theme.spacing[8]};
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .image {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      .deleteButton {
        position: absolute;
        top: ${({ theme }) => theme.spacing[8]};
        right: ${({ theme }) => theme.spacing[8]};

        &:hover path {
          fill: ${({ theme }) => theme.colors.semantic.accent.onAccent};
        }
      }
    }
  }
`;
